import { type AxiosResponse } from 'axios';
import { BASE_URL } from '@avanta/shared/constants/common';
import { service } from '@avanta/shared/services/api';
import { type User } from '@avanta/shared/types/users';
import { getUserId } from '@avanta/shared/utils/storage';

const USERS_URL = `${BASE_URL}users`;

interface UserServiceTypes {
  getUser: (userId?: string) => Promise<AxiosResponse<User>>;
}

export const UsersService: UserServiceTypes = {
  getUser: async (userId = getUserId()) => {
    if (!userId) {
      return Promise.reject(new Error('Missing user id'));
    }
    return service.get(`${USERS_URL}/${userId}`);
  },
};
